<template>
  <div>

    <van-address-edit
      :area-list="areaList"
      show-delete
      show-set-default
      show-search-result
      :show-delete="showDelete"
      :address-info="addressInfo"
      :search-result="searchResult"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      @delete="onDelete"
      @change-default="onChangeDefault"
      @change-area="onChangeArea"
    />

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { AddressEdit, Area } from 'vant'
  import AeraInfo from "../../assets/area/area.js"

  var payToUrl = ''

  export default {
    components: {
      [AddressEdit.name]: AddressEdit,
      Area
    },
    name: 'addressAdd',
    data() {
      return {
        searchResult: [],
        areaList: AeraInfo, //引用地区信息
        showArea: false,
        valueArea: '', //地区值
        arrArea: [], //存放地区数组
        showDelete: false,
        addressInfo: {
          id: 0,
          name: '',
          tel: '',
          province: '',
          city: '',
          county: '',
          areaCode:'',
          areaCode:'',
          areaCode:'',
          addressDetail: '',
          status: 0,
          isDefault: false,
          area_val: ''
        },
        toType: 0,
        listLength: 0
      };
    },
    created(){
      if(this.$route.query.id){
        this.showDelete = true
        this.$api.get('address/show', {'id':this.$route.query.id}, r=>{
          this.addressInfo.id = r.data.id
          this.addressInfo.name = r.data.name
          this.addressInfo.tel = r.data.tel
          this.addressInfo.province = r.data.province
          this.addressInfo.city = r.data.city
          this.addressInfo.county = r.data.county
          this.addressInfo.addressDetail = r.data.detail
          this.addressInfo.area_val = r.data.area_val
          this.addressInfo.status = r.data.status
          this.addressInfo.isDefault = (r.data.status == 1) ? true : false
          this.addressInfo.areaCode = r.data.area_val[0].code
          this.addressInfo.areaCode = r.data.area_val[1].code
          this.addressInfo.areaCode = r.data.area_val[2].code
          this.valueArea = r.data.area_val
        })
      }else{
        this.addressList()
      }
      this.toType = this.$route.query.type
    },
    beforeRouteEnter(to, from, next){
      next(vm =>{
        //console.log(from) // 上一页面的路由信息
        payToUrl = from.fullPath
      })
    },
    methods: {
      addressList() {
        this.$api.get('address', null, r=>{
          if(r.data.length === 0){
            this.addressInfo.isDefault = true
          }
        })
      },
      onSave(content) {
        content.area_val = this.valueArea
        if(this.addressInfo.id === 0){
          this.$api.post('address/store', content, r=>{
            if(this.toType === 1){
              this.$router.push(payToUrl)
            }else{
              this.$router.push('address')
            }
          })
        }else{
          this.$api.post('address/update', content, r=>{
            if(this.toType === 1){
              this.$router.push(payToUrl)
            }else{
              this.$router.push('address')
            }
          })
        }
      },
      onDelete() {
        this.$api.post('address/destroy', {id:this.addressInfo.id}, r=>{
          this.$router.push('address')
        })
      },
      onChangeArea(val) {
        this.valueArea = val
      },
      onChangeDefault(val) {
        //this.addressInfo.status = val ? 1 : 0
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/users/addressAddEdit.vue